export const bundesligasaison202627Startet = {
  "id": "bundesligasaison-2026-27-startet",
  "title": "Die Bundesligasaison 2026/27 startet",
  "slug": "bundesligasaison-2026-27-startet",
  "publishedAt": "2026-08-13T09:00:00Z",
  "author": "Rugby Bundesliga Redaktion",
  "language": "de",
  "readTime": "6 min",
  "tags": [
    "Rugby",
    "Bundesliga",
    "Saisonstart",
    "1. Bundesliga",
    "2. Bundesliga",
    "YouTube",
    "Saison 2026/27"
  ],
  "excerpt": "Am 5. September beginnt die neue Bundesligasaison. Nach einer intensiven Vorbereitung kehren die Teams auf den Platz zurück und kämpfen wieder um Meisterschaft, Aufstieg, Klassenerhalt und die entscheidenden Plätze für die Endrunde.",
  "img": "/images/bundesligasaison-2026-27-startet.png",
  "blocks": [
    {
      "type": "paragraph",
      "content": "Am 5. September beginnt die neue Bundesligasaison. Nach einer intensiven Vorbereitung kehren die Teams auf den Platz zurück und kämpfen wieder um Meisterschaft, Aufstieg, Klassenerhalt und die entscheidenden Plätze für die Endrunde."
    },
    {
      "type": "paragraph",
      "content": "Die Voraussetzungen versprechen eine hochspannende Spielzeit. Alle Ligen sind vollständig besetzt. In der 1. Bundesliga wartet der Kampf um die Meisterschaft, während die 2. Bundesliga mit zwei engen Staffeln, einem klaren Aufstiegsrennen und zusätzlichen Platzierungsspielen in die Saison geht."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "1. Bundesliga künftig auch auf YouTube"
    },
    {
      "type": "paragraph",
      "content": "Ein wichtiger Schritt für die Sichtbarkeit des deutschen Clubrugby ist der neue YouTube Kanal der Rugby Bundesliga:"
    },
    {
      "type": "list",
      "items": [
        { "content": "YouTube Kanal der Rugby Bundesliga", "url": "https://www.youtube.com/@RDBundesliga" }
      ],
      "ordered": false
    },
    {
      "type": "paragraph",
      "content": "In der Saison 2026/27 sollen dort Spiele der 1. Bundesliga gestreamt werden. Der Kanal wird damit zur zentralen Anlaufstelle für Livebilder aus der höchsten deutschen Spielklasse und bietet Fans die Möglichkeit, ausgewählte Begegnungen auch über den eigenen Verein hinaus zu verfolgen."
    },
    {
      "type": "paragraph",
      "content": "Der Kanal ist bereits erreichbar. Dort werden künftig Übertragungen und weitere Inhalte rund um die 1. Bundesliga veröffentlicht."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Der sportliche Ausblick auf die 1. Bundesliga"
    },
    {
      "type": "paragraph",
      "content": "Die große Frage zum Saisonstart lautet: Kann irgendjemand den SC Frankfurt 1880 stoppen?"
    },
    {
      "type": "paragraph",
      "content": "Nach fünf Meisterschaften und einer dominanten Saison 2025/26 geht Frankfurt erneut als der Maßstab der Liga in den Wettbewerb. Tempo, Physis, Tiefe im Kader und die Fähigkeit, in den entscheidenden Momenten da zu sein: Der Meister hat im vergangenen Jahr eindrucksvoll gezeigt, warum der Titel wieder nach Frankfurt ging. Der Anspruch ist klar. Die nächste Meisterschaft soll folgen."
    },
    {
      "type": "paragraph",
      "content": "Doch die Liga hat im Finale gesehen, dass auch Frankfurt zu schlagen ist. Der SC Neuenheim hat den Champion in einem hochklassigen Endspiel gefordert und bewiesen, dass die Lücke an der Spitze kleiner werden kann. Genau darin liegt die Spannung dieser neuen Saison: Setzt Frankfurt seine Serie fort oder gelingt es einem Herausforderer, die Dominanz zu durchbrechen?"
    },
    {
      "type": "paragraph",
      "content": "Für den SC Neuenheim wird es darum gehen, die Rolle des direkten Verfolgers zu festigen. Mehrere erfahrene Spieler haben ihre Karriere beendet. Umso spannender wird sein, wie schnell die nächste Generation Verantwortung übernimmt und ob Neuenheim die Qualität besitzt, über die gesamte Saison wieder ganz oben mitzuspielen."
    },
    {
      "type": "paragraph",
      "content": "Die RG Heidelberg hat sich ebenfalls eindrucksvoll zurückgemeldet. Nach einer schwierigen Saison 2024/25 fand die RGH Schritt für Schritt zu alter Stärke zurück und steigerte sich während der Saison 2025/26 kontinuierlich. Jetzt folgt der Moment der Bestätigung. Eine Halbfinalteilnahme wäre nicht nur ein Erfolg, sondern ein klares Signal an die Konkurrenz: Die RGH ist wieder bereit, die Spitze anzugreifen."
    },
    {
      "type": "paragraph",
      "content": "Dahinter wartet ein Verfolgerfeld, das es in sich hat. Der TSV Handschuhsheim will den Umbruch mit neuen Kräften aus der eigenen Jugend in neue Energie verwandeln. Hannover 78 möchte die starke Hinrunde der vergangenen Saison bestätigen. Entscheidend wird sein, ob die Verletzungsrückkehrer wieder an ihre alte Form anknüpfen können. Gleichzeitig bleibt abzuwarten, wie sich der Kuhlmanneffekt auswirkt. Mit dem ehemaligen Nationaltrainer kommt viel Erfahrung in das Trainerteam der 78er. Der Heidelberger RK arbeitet sich Jahr für Jahr nach vorn und hat die Plätze eins bis vier fest im Blick."
    },
    {
      "type": "paragraph",
      "content": "München RFC und Germania List können jede Mannschaft der Liga vor große Aufgaben stellen. Beide Teams haben in der vergangenen Saison gezeigt, welches Potenzial in ihnen steckt. Jetzt geht es darum, aus einzelnen starken Auftritten dauerhafte Konstanz zu machen. Gelingt das, ist der Weg ins gesicherte Mittelfeld offen. Gelingt es nicht, wartet ein harter Kampf um jeden Punkt."
    },
    {
      "type": "paragraph",
      "content": "Für Berliner RC und RC Luxemburg beginnt die Saison mit einem klaren Ziel: Die knappen Spiele des vergangenen Jahres müssen endlich in Siege verwandelt werden. Wer früh punktet, kann sich Luft verschaffen. Wer die ersten Chancen liegen lässt, könnte schnell tief im Kampf um den Klassenerhalt stecken."
    },
    {
      "type": "paragraph",
      "content": "Die 1. Bundesliga verspricht damit von Beginn an große Duelle, offene Rechnungen und einen Meister, den alle jagen werden."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Der sportliche Ausblick auf die 2. Bundesliga"
    },
    {
      "type": "paragraph",
      "content": "In der 2. Bundesliga ist die Botschaft aus Heusenstamm unüberhörbar: Der Aufstieg ist das Ziel."
    },
    {
      "type": "paragraph",
      "content": "Der RK Heusenstamm will nach der Meisterschaft in der vergangenen Saison die Mission „Back to the Future“ vollenden und in die 1. Bundesliga zurückkehren. Nach dem Rückzug aus dem Oberhaus wurde in Heusenstamm ein klarer Plan entwickelt. Die Mannschaft sollte wachsen, sich stabilisieren und dann mit voller Überzeugung den nächsten Schritt gehen. Diese Saison ist der entscheidende Moment dieses Plans."
    },
    {
      "type": "paragraph",
      "content": "Doch der Weg wird alles andere als einfach. In der Staffel Süd West wartet ein echtes Rennen um die Spitze. Die StuSta Dragons, RC Rottweil und RC Unterföhring haben bereits im vergangenen Jahr gezeigt, wie eng der Kampf um die Meisterschaft sein kann. Alle drei Mannschaften wissen, dass ein guter Saisonstart enormen Druck auf die Konkurrenz ausüben kann."
    },
    {
      "type": "paragraph",
      "content": "Hinter diesem Führungsquartett lauern RSV Köln, Heidelberger TV, RC Welferdange und Aufsteiger RC Stuttgart. Hier geht es um weit mehr als Tabellenplätze. Wer kann den Anschluss nach oben herstellen? Wer entwickelt sich zur Überraschung der Saison? Und wer muss sich früh auf einen intensiven Kampf um den Klassenerhalt einstellen? Jede Antwort wird auf dem Platz gegeben."
    },
    {
      "type": "paragraph",
      "content": "In der Staffel Nord Ost ist die Ausgangslage noch offener. RC Leipzig, Hamburger RC und RK 03 Berlin führen die Gruppe der Titelanwärter an. Doch mit FC St. Pauli, Berliner SV und Victoria Linden stehen drei Mannschaften bereit, die den Favoriten jederzeit gefährlich werden können. Die direkten Duelle waren im vergangenen Jahr häufig eng, körperlich und bis zum Schluss umkämpft. Genau das macht diese Staffel so reizvoll."
    },
    {
      "type": "paragraph",
      "content": "Kann die Verfolgergruppe den Anschluss an die Spitze herstellen? Gelingt es einem Team, die etablierte Reihenfolge aufzubrechen? Oder setzen sich Leipzig, Hamburg und RK 03 Berlin erneut ab? Die Antworten auf diese Fragen können Woche für Woche ein neues Gesicht bekommen."
    },
    {
      "type": "paragraph",
      "content": "RU Hohen Neuendorf und Aufsteiger VfR 06 wollen ihre eigene Geschichte schreiben. Die RU hat im vergangenen Jahr gezeigt, dass sie in engen Partien mithalten kann und weiter an den Anforderungen der 2. Bundesliga wächst. Beim VfR 06 wird besonders spannend sein, wie der starke U18 Jahrgang in den Herrenbereich integriert wird. Gerade solche neuen Impulse können einer Saison eine unerwartete Wendung geben."
    },
    {
      "type": "paragraph",
      "content": "Die Zutaten für eine packende Saison sind vorhanden: ambitionierte Aufstiegskandidaten, enge Verfolgergruppen, neue Mannschaften und jede Menge Teams mit etwas zu beweisen. Jetzt beginnt der Wettbewerb um Punkte, Platzierungen und die Chance, sich in dieser Bundesliga einen Namen zu machen."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Platzierungsspiele und Scorebonus"
    },
    {
      "type": "paragraph",
      "content": "Die 2. Bundesliga erhält nach der Hauptrunde eine zusätzliche sportliche Dimension. Neben den Halbfinals und dem Finale finden Platzierungsspiele zwischen den Staffeln Nord Ost und Süd West statt."
    },
    {
      "type": "paragraph",
      "content": "Die Mannschaften auf den Tabellenplätzen drei bis sieben treffen dabei jeweils auf den entsprechenden Tabellenplatz der anderen Staffel. Der Tabellendritte spielt gegen den Tabellendritten, der Tabellenvierte gegen den Tabellenvierten und entsprechend weiter bis zum siebten Tabellenplatz. Damit erhalten zahlreiche Teams auch nach der Hauptrunde ein bedeutendes Pflichtspiel und die Möglichkeit, ihre Saison mit einem direkten Vergleich gegen einen Gegner aus der anderen Staffel abzuschließen."
    },
    {
      "type": "paragraph",
      "content": "Mit Beginn der neuen Saison wird zudem der zulässige Scorebonus von bisher 20 auf künftig 18 Punkte reduziert."
    },
    {
      "type": "paragraph",
      "content": "Informationen zur Lizenzvergabe und den Wildcards für die Saison 2026/27 finden sich in folgendem Artikel:"
    },
    {
      "type": "list",
      "items": [
        { "content": "Alle Lizenzen und Wildcards vergeben: Bundesligen starten in voller Stärke", "url": "/neues/lizenzvergabe-wildcards-bundesliga-2026-27" }
      ],
      "ordered": false
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Spielpläne und Termine"
    },
    {
      "type": "paragraph",
      "content": "Die aktuellen Spielpläne sind über Rugby Deutschland abrufbar:"
    },
    {
      "type": "list",
      "items": [
        { "content": "1. Bundesliga", "url": "https://www.rugbydeutschland.org/1-bundesliga-384878v4/leagues/12215/seasons/220" },
        { "content": "2. Bundesliga Nord Ost", "url": "https://www.rugbydeutschland.org/2-bundesliga-nord-ost-384879v4/leagues/2162/seasons/220" },
        { "content": "2. Bundesliga Süd West", "url": "https://www.rugbydeutschland.org/2-bundesliga-sud-west-384880v4/leagues/2161/seasons/220" }
      ],
      "ordered": false
    },
    {
      "type": "paragraph",
      "content": "Die wichtigsten Termine der Saison im Überblick:"
    },
    {
      "type": "list",
      "items": [
        "Saisonbeginn: 5. September 2026",
        "Beginn der Winterpause: 28. November 2026",
        "Start der Rückrunde: 13. März 2027",
        "Ende der Hauptrunde 2. Bundesliga: 15. Mai 2027",
        "Halbfinals und Platzierungsspiele 2. Bundesliga: 22. Mai 2027",
        "Ende der Hauptrunde 1. Bundesliga: 5. Juni 2027",
        "Finale 2. Bundesliga: 5. Juni 2027",
        "Relegation und Bundesligafinale: 19. Juni 2027"
      ],
      "ordered": false
    },
    {
      "type": "paragraph",
      "content": "Jetzt zählt es. Die Teams haben sich vorbereitet, die Spielpläne stehen fest und die neue Bundesligasaison kann beginnen."
    },
    {
      "type": "footer",
      "content": "Artikel-Bild: © Susanna Wolf"
    }
  ]
};
